import { __extends } from "tslib";
import React from 'react';
import { URLS } from '@wix/da-url';
var LogoutItem = /** @class */ (function (_super) {
    __extends(LogoutItem, _super);
    function LogoutItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LogoutItem.prototype.render = function () {
        var url = URLS.LOGOUT;
        if (process.env.NODE_ENV !== 'production' || process.env.XHR_ENV === 'vm') {
            url = url.replace('deviantart.com', 'deviantart.lan');
        }
        var _a = this.props, formRef = _a.formRef, token = _a.token, label = _a.label;
        return (React.createElement(React.Fragment, null,
            React.createElement("form", { id: "logout-form", ref: formRef, action: url, method: "POST" },
                React.createElement("input", { type: "hidden", name: "validate_token", value: token, autoComplete: "off" })),
            label));
    };
    return LogoutItem;
}(React.Component));
export { LogoutItem };
export default LogoutItem;
//# sourceMappingURL=LogoutItem.js.map